import Pullquote from './pullquote'

export { default as PullquoteQuery } from './pullquote.query'
export default Pullquote
